export default __webpack_public_path__ + "static/media/addtmember.7f8a8bad.svg";